import { type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import { Panel } from '../Panel';
import { NotificationTeamEmail } from './NotificationTeamEmail';

// Where email goes. The caller's own address is the SERVER's `delivery_address`
// and is read-only here: it follows the account. The team block is the owner's
// alone; `showTeam` is decided by the container, which holds the role.

export function NotificationSendTo(props: {
  readonly address: string | null;
  readonly showTeam: boolean;
  readonly token: string | null;
}): JSX.Element {
  return (
    <Panel title={t('notifications_settings.send_to.heading')} class="notification-send-to">
      <h3 class="notification-send-to__label">{t('notifications_settings.send_to.own_label')}</h3>
      <p class="notification-send-to__value">
        {props.address ?? t('notifications_settings.send_to.own_none')}
      </p>
      <Show when={props.address !== null}>
        <p class="card__desc">{t('notifications_settings.send_to.own_hint')}</p>
      </Show>
      <Show when={props.showTeam}>
        <NotificationTeamEmail token={props.token} />
      </Show>
    </Panel>
  );
}
